import React, { useEffect, useState } from 'react'
import { useNavigate} from"react-router-dom";        

import AdminBreadcrumb from '../../Common/AdminBreadcrumb';
import {UserDetail, SendAdminEmail} from  '../../../../API/admin'
import Editor from '../../Common/Editor'
import Swal from 'sweetalert2'
import Loader from '../../Common/Loader';
import { Link } from 'react-router-dom';

const SendEmailUser = () => {
    let navigate = useNavigate();

    const [data, setData] = useState(null);
    const [emailData, setEmailData] = useState({
        to: '',
        subject: '',
        body: ''
    });
    let [loaderStatus, setloaderStatus] = useState(true)
    const adminBreadcrumbLinks = [
        { label: 'Dashboard', to: '/admin/dashboard', active: false },
        { label: 'User', to: '/users', active: false },
        { label: 'Send Email', to: '', active: true },
    ];

    useEffect(() => {
        let callAPI = async () => {
            const urlParams = new URLSearchParams(window.location.search);
            var params;
            var userID;
            var filter = urlParams.get('filter'); 
            console.log(filter)
            params = urlParams.get('id');
            if (params == null) {
               let role  = urlParams.get('role');   
               userID = { id: null , role: role};
                
            
            } else {
             userID = { id: params, role: null };
            }
            setloaderStatus(true);
            let res = await UserDetail(userID);
            console.log("API ", res.status);
            if (res.status) {
                if (res.data.length > 1 || filter!=null) {
                    let emailArray = [];
                    res.data.map((user) => {
                        emailArray.push(user.email)
                    })
                    setData(emailArray);
                    setEmailData(prevState => ({
                        ...prevState,
                        to: emailArray
                    }));
                    console.log(emailArray)
                } else {
                    setData(res.data.user);
                    setEmailData(prevState => ({
                        ...prevState,
                        to: res.data.user.email
                    }));

                }
            setloaderStatus(false);

            } else {
            setloaderStatus(false);

            }
        };
        callAPI();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEmailData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleEditorChange = (content) => {
        setEmailData(prevState => ({
            ...prevState,
            body: content
        }));
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        // Call your API to send email using emailData
        // Example:
        // let res = await SendEmailAPI(emailData);
        // if(res.status) {
        //   // handle success
        // }
        setloaderStatus(true);

        let res = await SendAdminEmail(emailData);
        if (res.data.status) {
            setloaderStatus(false);

            Swal.fire({
                title: "Email sent successfully?",
                text: "Email has been sent to user.",
                icon: "success" }).then(async (result) => {
                    if (result.isConfirmed) {
                       navigate('/users')
                    }
                });
                
        } else {
            setloaderStatus(false);

            Swal.fire({
                title: "Something went wrong",
                text: "Unable to send email cuurently, Try Again Later..",
                icon: "error" });
        }
        console.log(res.data.status)

        console.log("Form Submitted", emailData);
    };

    return (
        <>
             {loaderStatus ? <Loader /> : null}
            <AdminBreadcrumb links={adminBreadcrumbLinks} />
            {
                data != null ? (
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label htmlFor="email" className="form-label">To</label>
                            <input
                                type="email"
                                className="form-control"
                                id="email"
                                name="to"
                                value={emailData.to}
                                readOnly
                            />
                           
                        </div>
                        <div className="mb-3">
                            <label htmlFor="subject" className="form-label">Subject</label>
                            <input  
                                type="text"
                                className="form-control"
                                id="subject"
                                name="subject"
                                value={emailData.subject}
                                onChange={handleChange}
                            />
                        </div>
                        {/* <div className="mb-3">
                            <label htmlFor="body" className="form-label">Body</label>
                            <textarea
                                className="form-control"
                                id="body"
                                name="body"
                                value={emailData.body}
                                onChange={handleChange}
                            />
                        </div> */}
                        <label htmlFor="body" className="form-label">body</label>
                        <Editor  onChange={handleEditorChange}/>
                        <div className='d-flex align-items-center'>

                        <button  type="submit" className=" mt-3 btn btn-primary  me-3">
                            Send Email
                        </button>
                        <Link to={'/users'}>
                            <button  type="buttton" className=" mt-3 btn btn-secondary">
                            Cancel
                            </button>
                        </Link>

                        </div>
                    </form>
                ) : (
                    null
                )
            }
        </>
    );
};

export default SendEmailUser